import styled from "@emotion/styled";
import React from "react";
import { LoadingCard } from "../../components/card/loading";
import { LoadingH1 } from "../../components/typography";
import { MainContainer } from "../../containers/main-container";
import GameList, { GAME_ITEM_SIZE } from "./game-list";

interface LoadingMock {
  textWidth: number;
  amountOfItems: number;
}

const loadingMocks: LoadingMock[] = [
  { textWidth: 70, amountOfItems: 5 },
  { textWidth: 125, amountOfItems: 7 },
  { textWidth: 185, amountOfItems: 5 },
];

const LoadingGameCard = styled(LoadingCard)`
  height: ${GAME_ITEM_SIZE};
  margin: 0;
`;

const CalendarLoading: React.FC = () => (
  <MainContainer>
    {loadingMocks.map((loadingMock, i) => (
      <React.Fragment key={`loading-calendar-game-section-${i}`}>
        <LoadingH1 width={loadingMock.textWidth} totalHeight={41} />
        <GameList amountOfGames={loadingMock.amountOfItems}>
          {[...Array(loadingMock.amountOfItems).keys()].map((j) => (
            <LoadingGameCard key={`loading-calendar-game-${i}-${j}`} />
          ))}
        </GameList>
      </React.Fragment>
    ))}
  </MainContainer>
);

export default CalendarLoading;
